<template>
  <div class="plantasSite">
    <div class="plantas ui-container" v-if="empreendimentoAndares">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="ui-title ui-title--uppercase ui-title--white">
              <b>
                Plantas
              </b>
            </h1>
          </div>
          <div class="col-12">
            <carousel
            v-if="empreendimentoAndares.length >= 1"
            :per-page="1"
            :paginationPadding="5"
            :paginationSize="15"
            :paginationActiveColor="'#009337'"
            :perPageCustom="[[480, 1], [768, 2], [1024, 3]]"
            :loop="false"
            :autoplay="false">
              <slide v-for="(floor,index) in empreendimentoAndares" :key="index">
                <div class="plantas__itens">
                  <div class="plantas__box" :class="{'active' : index == tabOne}" @click="aciveTab(index)">
                    {{floor.name}}
                  </div>
                </div>
              </slide>
            </carousel>
          </div>
        </div>
      </div>
    </div>
    <div class="tab ui-container" v-for="(floor,index) in empreendimentoAndares" :key="index" v-show="index == tabOne">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-12 mh">
            <div class="ui-subtitle--interna ui-subtitle--interna--white ui-subtitle--interna--left">
              <h2>
                {{floor.name}}
              </h2>
            </div>
            <div class="area_apartamentos">
              <div v-for="(apartment,index) in floor.apartments" :key="index">
                <div class="tab__subtitle">
                  <span>
                    {{apartment.name}}
                  </span>
                </div>
                <div class="tab__opcoes" v-if="apartment.features.length >= 1">
                  <ul class="row">
                    <li v-for="(feature,index) in apartment.features" :key="index" v-if="index < 2">
                      <img :src="feature.image" :alt="feature.name"> {{feature.name}}
                    </li>
                  </ul>
                </div>
                <div class="ui-description ui-description--italic ui-description--white lh-26" v-html="apartment.description">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="h-100 tab__image d-none d-lg-block">
        <div class="image-sticky">
          <img :src="floor.image" :alt="floor.name" :usemap="'#Map_'+floor.id" width="471px" height="auto" class="mapShow">
          <span v-if="index === empreendimentoAndares.length - 1">{{activeMap(floor.id)}}</span>
          <map :name="'Map_'+floor.id">
            <area class="tab__area" v-for="(apartment,indexAp) in floor.apartments" @click="openViewer(index, indexAp)" :key="indexAp" shape="poly" :coords="apartment.coordinates" :title="apartment.name" v-tooltip="{content: apartment.name, classes: 'toolt'}">
          </map>
        </div>
      </div>
      <div :class="'images_' + index" v-viewer="{movable: true, title: [1, (image) => `${image.alt}`], scalable: false}" style="display: none;">
        <img v-for="(apartment,indexAp) in floor.apartments" :key="indexAp" :src="apartment.image" :alt="apartment.name">
      </div>
      <!-- esta parte aparece somente no mobile -->
      <div class="w-100 plantas_mobile d-block d-md-none">
        <carousel
          v-if="floor.apartments.length >= 1"
          :per-page="1"
          :paginationPadding="5"
          :paginationSize="15"
          :paginationActiveColor="'#13182c'"
          :perPageCustom="[[480, 1], [768, 2], [1024, 3]]"
          :loop="false"
          :autoplay="false"
          :paginationEnabled="false"
          :navigationEnabled="true"
          navigationNextLabel='<i class="fa fa-chevron-right button_right"></i> Próxima'
          navigationPrevLabel='Anterior <i class="fa fa-chevron-left button_left" aria-hidden="true"></i>'
          >
          <slide v-for="(apartment,indexAp) in floor.apartments" :key="indexAp" :src="apartment.image">
              <div class="galeria__image ui-image--cover" @click="openViewerMobile(index, indexAp)" :style="'background-image: url('+apartment.image+')'">
                <div class="galeria__image__name ui-image--cover">
                  <div class="galeria__image__title">
                    {{apartment.name}}
                  </div>
                </div>
              </div>
          </slide>
        </carousel>
        <!-- repetir imagens aqui também, pois aqui são as imagens da galeria -->
        <div :class="'slider'+index" v-viewer="{movable: false, title: [1, (image) => `${image.alt}`], scalable: false}" style="display: none;">
          <img v-for="(apartment,indexAp) in floor.apartments" :key="indexAp" :src="apartment.image" :alt="apartment.name">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import Tooltip from 'vue-directive-tooltip'
import 'vue-directive-tooltip/css/index.css'
Vue.use(Viewer)

global.jQuery = require('jquery')
var $ = global.jQuery
window.$ = $

require('../../../node_modules/maphilight/jquery.maphilight.min.js')

Vue.use(Tooltip)

export default {
  data () {
    return {
      tabOne: 0,
      dataId: null
    }
  },
  components: {
    Carousel,
    Slide
  },
  computed: {
    ...mapGetters([
      'empreendimentoAndares'
    ])
  },
  methods: {
    aciveTab (a) {
      this.tabOne = a
      this.showMap()
    },
    activeMap (id) {
      if (id !== this.dataId) {
        this.dataId = id
        this.showMap()
      }
    },
    openViewer (indexEmp, indexAp) {
      const viewer = this.$el.querySelector('.images_' + indexEmp).$viewer
      viewer.view(indexAp)
      viewer.show()
    },
    openViewerMobile (id, indexAp) {
      const viewer = this.$el.querySelector('.slider' + id).$viewer
      viewer.view(indexAp)
      viewer.show()
    },
    showMap () {
      setTimeout(() => {
        this.$nextTick(() => {
          $('.mapShow').maphilight(
            {
              strokeColor: '009337',
              fillColor: '009337',
              fillOpacity: 0.8,
              shadow: true
            }
          )
          $('.mapShow').css(
            {
              backgroundRepeat: 'no-repeat',
              position: 'sticky',
              top: '150px',
              height: 'auto'
            }
          )
          $('.mapShow canvas').css(
            {
              height: 'auto'
            }
          )
        })
      })
    }
  },
  mounted () {
    this.$store.dispatch('showEmpreendimentoAndares', this.$route.params.slug)
  }
}
</script>
<style lang="scss">
@import '../../assets/scss/_variables.scss';
.vue-tooltip {
  background: #009337!important;
  color: white;
  border-radius: 5px;
  padding: 5px 10px 4px;
  z-index: 10!important;
}
.viewer-one-to-one{
  display: none;
}
map{
  position: absolute;
  top:-20px;
  right: 50%;
}
.plantasSite{
  .tab__image {
    padding-top: 3em;
    .mapShow {
      background-repeat: no-repeat;
    }
  }
  canvas{
    height: auto;
  }
  .modal-header{
    h4{
      color: #33353b;
      margin: 0px;
      font-size: 30px;
    }
  }
  .plantas {
    background: $primary;
    h1 {
      margin-bottom: 40px;
    }
    &__itens {
      padding: 0 10px;
    }
    &__box {
      background: transparent;
      border-radius: 5px;
      border: 2px $tabs solid;
      color: $tabs;
      cursor: pointer;
      overflow: hidden;
      padding: 10px 40px;
      position: relative;
      text-align: center;
      text-transform: uppercase;
    }
    .active {
      border-color: white;
      border-bottom-color: $green;
      border-radius: 5px 5px 0 0;
      color: white;
      font-weight: 600;
      &:before {
        background: $green;
        bottom: 0;
        content: '';
        height: 5px;
        left: 0;
        position: absolute;
        width: 100%;
      }
    }
  }
  .tab {
    background-image: linear-gradient(to right, $silver 50%, #fff 10%);
    position: relative;
    padding-bottom: 0px;
    .ui-description {
      margin-bottom: 20px;
    }
    &__subtitle {
      margin-bottom: 30px;
      span {
        color: white;
        font-weight: 600;
        font-size: 24px;
        position: relative;
        &:before {
          background: $green;
          bottom: -10px;
          content: '';
          height: 4px;
          position: absolute;
          width: 100%;
        }
      }
    }
    &__image {
      left: 54%;
      position: absolute;
      top: 0px;
      transition: all 0.3s;
      &:hover {
        opacity: 0.8;
        transition: all 0.3s;
      }
    }
    &__opcoes {
      margin-bottom: 10px;
      ul {
        margin: 0px;
        li {
          color: white;
          font-size: 16px;
          font-style: italic;
          font-weight: 300;
          margin-bottom: 10px;
          padding-right: 30px;
          img {
            margin-right: 5px;
          }
        }
      }
    }
    .area_apartamentos {
      padding-bottom: 30px;
    }
    &__area{
      cursor:pointer;
    }
    &__opacity {
      margin-top: 20px;
      opacity: 1;
      * {
        opacity: 1;
      }
    }
    &__subtitle-option {
      color: white;
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 20px;
      margin-top: 40px;
    }

    @media (max-width: 1200px){
      &__opcoes {
        margin-bottom: 10px;
      }
      &__subtitle-option {
        margin-bottom: 20px;
      }
      &__subtitle {
        margin-bottom: 40px;
      }
    }
    @media (max-width: 1035px){
      &__image {
        left: 50%;
      }
    }
    @media (max-width: 991px){
      background-image: none;
      background: $silver;
      &__mobile-image {
        margin-top: 10px;
        margin-bottom: 20px;
      }
    }
  }
  .mh {
    min-height: 630px;
    @media (max-width: 767px){
      min-height: inherit;
    }
  }
  .image-sticky {
    position: sticky!important;
    top: 150px!important;
    padding-top: 15px;
  }
  .galeria {
    &__image {
      cursor: pointer;
      height: 650px;
      position: relative;
      transition: all 0.3s;
      &:hover {
        opacity: 0.8;
        transition: all 0.3s;
      }
    }
    &__image__name {
      background-image: url(../../assets/img/bg_galeria.png);
      bottom: 0;
      height: 420px;
      left: 0;
      position: absolute;
      text-align: center;
      width: 100%;
    }
    &__image__title {
      bottom: 80px;
      color: white;
      font-size: 24px;
      font-style: italic;
      font-weight: 600;
      position: absolute;
      text-align: center;
      width: 100%;
    }
    @media (max-width: 1200px) {
      &__image {
        height: 500px;
      }
    }
    @media (max-width: 767px) {
      &__image__title {
        bottom: 50px;
        font-size: 20px;
      }
    }
  }
}
.viewer-title{
  font-size: 20px;
  font-weight: 900;
  opacity: 1;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaPlantas.vue